import { useEffect } from 'preact/hooks'
import { Store } from '../../net/store'
import { useStore } from '../useStore'
import { pageReload } from './pageReload'
import styles from './reload.module.css'

export const RELOAD_TEXT = 'Couldn’t load — tap to reload'

/** How many slots show their own Reload button: the banner stays away while one does. */
const inlineShown = new Store(0)

/**
 * The small fallback a lazy part of the page shows when its code would not load (D-066): one
 * button that reloads the page. `fill` centres it over a screen-sized slot.
 */
export function ReloadButton({ fill = false }: { fill?: boolean }) {
  useEffect(() => {
    if (!fill) return
    inlineShown.set(inlineShown.get() + 1)
    return () => inlineShown.set(inlineShown.get() - 1)
  }, [fill])
  const button = (
    <button type="button" class={styles.inline} onClick={() => pageReload.reloadNow()}>
      {RELOAD_TEXT}
    </button>
  )
  return fill ? <div class={styles.fill}>{button}</div> : button
}

/**
 * Over every screen: shown once a chunk failed and the page will not reload by itself (it
 * already did a moment ago), so the player is never left without a way out. Not while a slot
 * already offers its own button.
 */
export function ReloadBanner() {
  const state = useStore(pageReload.state)
  const inline = useStore(inlineShown)
  if (state !== 'failed' || inline > 0) return null
  return (
    <div class={styles.banner} role="alert">
      <ReloadButton />
    </div>
  )
}
